import React, { Component } from 'react';
import { Card, Modal } from 'antd';
import { connect } from 'react-redux';
import { Link, browserHistory } from 'react-router';

import moment from 'moment';
import { getMonthNums } from '@util/formatDate';

import DescriptionList from '@comm/DescriptionList';
import TableFile from '../comm/TableFile';
import TableAppoint from './TableAppoint';
import ComSeatTable from '../seat/ComSeatTable';
import TableRenew from '../contract/comm/TableRenew';

const { Description } = DescriptionList;
class Open extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataItem: this.props.data,
      seatVisible: false,
    };
  }

  componentDidMount() {
    const { data } = this.props;
    if (data && data.stations && data.stations.length > 0) {
      const diffMonth = getMonthNums(
        moment(data.beginDate).format('YYYY-MM-DD'),
        moment(data.endDate).format('YYYY-MM-DD'),
      );
      const stationsPrice = data.stations.reduce((prev, curr) => prev + curr.unit, 0);
      const originalPrice = diffMonth * stationsPrice;
      const discount = ((data.price / originalPrice) * 100).toFixed(2);
      this.setState({ originalPrice, discount });
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      dataItem: nextProps.data,
    });
  }

  findTypeName = type => {
    let typeName = '';
    this.props.expendType.forEach(item => {
      if (type === item.value) {
        typeName = item.key;
      }
    });
    return typeName;
  };

  handleVisible = flag => {};

  handleSeatVisible = flag => {
    this.setState({
      seatVisible: !!flag,
    });
  };

  changePage = renewBusinessUuid => {
    browserHistory.push(`/incubator/contract/${renewBusinessUuid}/info`);
  };

  render() {
    const { dataItem, discount, originalPrice, seatVisible } = this.state;
    return (
      <div className="form-open mb16">
        <Card title="入驻详情">
          <DescriptionList size="large" col={3}>
            <Description term="孵化器">{dataItem.incubator}</Description>
            <Description term="客户">{dataItem.custom}</Description>
            <Description term="项目">{dataItem.projectName}</Description>
            <Description term="收入类型">
              {+dataItem.type === 1 ? <span>地址收入</span> : <span>工位收入</span>}
            </Description>
            <Description term="工位数量">
              <a onClick={() => this.handleSeatVisible(true)}>{dataItem.stationNum}</a>
            </Description>
            <Description term="合同费用">
              {dataItem.price}
              {+discount > 0 && +discount < 100 ? (
                <span style={{ color: 'red', paddingLeft: '10px' }}>
                  (原价{originalPrice}元，折扣{discount}%)
                </span>
              ) : (
                ''
              )}
            </Description>
            <Description term="押金">{dataItem.indeposit}</Description>
            <Description term="记租时间">
              {moment.unix(dataItem.beginDate / 1000).format('YYYY-MM-DD')}
            </Description>
            <Description term="到期时间">
              {moment.unix(dataItem.endDate / 1000).format('YYYY-MM-DD')}
            </Description>
            <Description term="推荐人员">{dataItem.recommend}</Description>
            <Description term="联系电话">{dataItem.recommendTel}</Description>

            {dataItem.renewBusinessNo ? (
              <Description term="续签合同">
                <Link to={`/incubator/contract/${dataItem.renewBusinessUuid}/info`}>
                  {dataItem.renewBusinessNo}
                </Link>
              </Description>
            ) : null}
          </DescriptionList>
          {dataItem.renewBusinesses && dataItem.renewBusinesses.length > 0 ? (
            <DescriptionList size="large" col={1}>
              <Description term="续签合同">
                <TableRenew
                  dataSource={dataItem.renewBusinesses || []}
                  disabled
                  changePage={this.changePage}
                />
              </Description>
            </DescriptionList>
          ) : null}
          <DescriptionList size="large" col={1}>
            <Description term="附件">
              <TableFile dataSource={dataItem.files || []} disabled />
            </Description>
          </DescriptionList>
          <DescriptionList size="large" col={2}>
            <Description term="入驻说明">{dataItem.reason}</Description>
          </DescriptionList>
          <div>
            <TableAppoint data={dataItem.payables || []} />
          </div>
          <Modal
            visible={seatVisible}
            width={900}
            title="选择工位"
            onCancel={() => this.handleSeatVisible(false)}
            onOk={this.handleSetStation}
            footer={false}
          >
            <ComSeatTable
              {...this.props}
              incubatorUuid={dataItem ? dataItem.incubatorUuid : this.props.params.uuid}
              handleChange={this.handleStationChange}
              stations={dataItem ? dataItem.stations : []}
              disabled
              ref={node => {
                this.seatTable = node;
              }}
            />
          </Modal>
        </Card>
      </div>
    );
  }
}
export default connect(state => ({
  expendType: state.expend_type,
  company: state.company_list,
}))(Open);



// WEBPACK FOOTER //
// ./src/components/incubator/settled/FormOpen.js